import { useMutation } from '@tanstack/react-query';
import { useCompanyId } from '@/hooks/general/useCompanyId';
import { CreateSheinStorePayload } from '@app/pages/redirection/types';
import { createSheinStore } from '@app/api/redirection';
import { IStoreService } from '@typings/store';
import angular from 'angular';

export const useCreateSheinStoreMutation = () => {
  const companyId = useCompanyId();
  return useMutation({
    mutationFn: async (payload: CreateSheinStorePayload) => {
      const res = await createSheinStore(companyId, payload);
      return res.data.store;
    },
    onSuccess: (store) => {
      const service: IStoreService = angular.element(document.body).injector().get('StoreService');
      // send to appcues
      service.sendStoreConnectedEvents(store);
      // refresh stores
      service.getStores();
    },
  });
};
